import { ArrowBack } from "@mui/icons-material";

function ButtonBack({ onClick }: { onClick?: () => void }) {
  return (
    <div
      onClick={onClick}
      className="flex flex-row gap-2 items-center cursor-pointer w-fit hover:bg-hover-light-gray rounded-[4px] py-2 pr-2">
      <ArrowBack sx={{ color: "#009C4E", fontSize: "30px" }} />
      <p className="font-medium text-black dark:text-white  hover:dark:text-primary-green">Voltar</p>
    </div>
  );
}

export default ButtonBack;